module.exports = __webpack_public_path__ + "img/copy-paste.bd699d8c.svg";